import { BaseService } from 'hungry-core2'

import actions from '@actions'

export default class AccountsReceivable extends BaseService {
  toggleLoading = (on) => this.dispatch(actions.toggleARDashboardLoading(on))
}
